
import axios from "axios";
import { toast } from "sonner";
import { useGlobalContext } from "../GlobalContext";
import { useState } from "react";

export default function useAttendance() {
  const { baseurl, token, AdminId, setIsUnauthorised } = useGlobalContext();
const [loading, setLoading] = useState(false);

  /* FETCH ATTENDANCE RECORD */

const fetchAttendanceApi = async (
  payload,
  setDrivers,
  setDirtyMap,
  setLoading
) => {
  setLoading(true);
  setDirtyMap({});

  try {
    const body = {
      adminId: String(AdminId),
      driverCode: payload.driverCode || "",
      fromDate: payload.fromDate,
      toDate: payload.toDate,
    };

    const res = await axios.post(
      `${baseurl}/api/Driver/v1.0/getDriverAttendanceRecord`,
      body,
      { headers: { Authorization: `Basic ${token}` } }
    );

    if (res?.data?.responseCode === "401") {
      setIsUnauthorised(true);
      return;
    }

    if (res?.data?.responseCode !== "00") {
      toast.error(res?.data?.responseMessage || "Failed to fetch attendance");
      setDrivers([]);
      return;
    }

    const serverData = res.data.data || [];

    const normalized = serverData.map((d) => {
      const map = {};
      (d.attendance || []).forEach((a) => {
        if (a?.date && a?.status) {
          map[a.date] = a.status;
        }
      });
      return { ...d, attendanceMap: map };
    });

    setDrivers(normalized);
  } catch (err) {
    console.error(err);
    toast.error("Error fetching attendance");
    setDrivers([]);
  } finally {
    setLoading(false);
  }
};

  /* UPDATE ATTENDANCE */

  const updateAttendanceApi = async (dirtyData, setDirtyMap) => {
    if (!dirtyData || dirtyData.length === 0) {
      toast.message("No changes to save");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        adminId: String(AdminId),
        data: dirtyData,
      };

      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/updateDriverAttendanceRecord`,
        payload,
        { headers: { Authorization: `Basic ${token}` } }
      );

      if (res?.data?.responseCode === "401") {
        setIsUnauthorised(true);
        return;
      }

      if (res?.data?.responseCode === "00") {
        toast.success(res.data.responseMessage || "Attendance updated");
        setDirtyMap({});
           return true;
      } else {
        toast.error(res?.data?.responseMessage || "Update failed");
         return false;
      }
    } catch (err) {
      console.error(err);
      toast.error("Error updating attendance");
       return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    fetchAttendanceApi,
    updateAttendanceApi,
    loading,
  };
}

